export default __webpack_public_path__ + "static/media/typevan.9969b021.svg";